export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const AUTH_REFRESH = "AUTH_REFRESH";

// tree types
export const TOGGLE_EXPANDED = "TOGGLE_EXPANDED";
export const TOGGLE_CHECKED = "TOGGLE_CHECKED";
export const FETCH_NODES = "FETCH_NODES";

// user bundle
export const USERS_REQUESTING = "USERS_REQUESTING";
export const USERS_SUCCESS = "USERS_SUCCESS";
export const USERS_FAILURE = "USERS_FAILURE";
export const USER_FETCH = "USER_FETCH";

export const FETCH_ROLES = "FETCH_ROLES";
export const SET_ROLE = "SET_ROLE";

export const FETCH_TICKETS = "FETCH_TICKETS";
export const FETCH_TICKET = "FETCH_TICKET";

// content
export const FETCH_CONTENTS = "FETCH_CONTENTS";
export const FETCH_CONTENT = "FETCH_CONTENT";

export const FETCH_GALLERY = "FETCH_GALLERY";

// setting
export const OPEN_SETTING_DIALOG = "OPEN_SETTING_DIALOG";
export const OPEN_BANNEER_DIALOG = "OPEN_BANNEER_DIALOG";
export const OPEN_SETTING_LINKS_DIALOG = "OPEN_SETTING_LINKS_DIALOG";
export const DOMAIN_LINKS = "DOMAIN_LINKS";
export const STICKY_SETTING = "STICKY_SETTING";
export const FETCH_SETTING = "FETCH_SETTING";

// product

export const ORDERS_REQUESTING = "ORDERS_REQUESTING";
export const ORDERS_SUCCESS = "ORDERS_SUCCESS";
export const ORDERS_FAILURE = "ORDERS_FAILURE";

export const ORDERS_MAJOR_REQUESTING = "ORDERS_MAJOR_REQUESTING";
export const ORDERS_MAJOR_SUCCESS = "ORDERS_MAJOR_SUCCESS";
export const ORDERS_MAJOR_FAILURE = "ORDERS_MAJOR_FAILURE";

export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const FETCH_CRAWLER_PRODUCTS = "FETCH_CRAWLER_PRODUCTS";

export const FETCH_PACKAGE_TYPES = "FETCH_PACKAGE_TYPES";
export const CURRENT_PACKAGE_TYPE = "CURRENT_PACKAGE_TYPE";

export const FETCH_ATTRIBUTES = "FETCH_ATTRIBUTES";
export const CURRENT_ATTRIBUTE = "CURRENT_ATTRIBUTE";

export const FETCH_BRANDS = "FETCH_BRANDS";
export const CURRENT_BRAND = "CURRENT_BRAND";

export const FETCH_ITEM_PRODUCT = "FETCH_ITEM_PRODUCT";
export const CURRENT_ITEM_PRODUCT = "CURRENT_ITEM_PRODUCT";

export const MARKETER_REQUESTING = "MARKETER_REQUESTING";
export const MARKETER_SUCCESS = "MARKETER_SUCCESS";
export const MARKETER_FAILURE = "MARKETER_FAILURE";

export const REWARD_REQUESTING = "REWARD_REQUESTING";
export const REWARD_SUCCESS = "REWARD_SUCCESS";
export const REWARD_FAILURE = "REWARD_FAILURE";

export const PERIOD_REQUESTING = "PERIOD_REQUESTING";
export const PERIOD_SUCCESS = "PERIOD_SUCCESS";
export const PERIOD_FAILURE = "PERIOD_FAILURE";

export const REQUESTS_REQUESTING = "REQUESTS_REQUESTING";
export const REQUESTS_SUCCESS = "REQUESTS_SUCCESS";
export const REQUESTS_FAILURE = "REQUESTS_FAILURE";

export const REGION_REQUESTING = "REGION_REQUESTING";
export const REGION_SUCCESS = "REGION_SUCCESS";
export const REGION_FAILURE = "REGION_FAILURE";

export const TRANSACTIONS_REQUESTING = "TRANSACTIONS_REQUESTING";
export const TRANSACTIONS_SUCCESS = "TRANSACTIONS_SUCCESS";
export const TRANSACTIONS_FAILURE = "TRANSACTIONS_FAILURE";

export const FINANCE_REQUESTING = "FINANCE_REQUESTING";
export const FINANCE_SUCCESS = "FINANCE_SUCCESS";
export const FINANCE_FAILURE = "FINANCE_FAILURE";

export const NOTIFICATION_REQUESTING = "NOTIFICATION_REQUESTING";
export const NOTIFICATION_SUCCESS = "NOTIFICATION_SUCCESS";
export const NOTIFICATION_FAILURE = "NOTIFICATION_FAILURE";

export const DIALOG_PAYLOAD = "DIALOG_PAYLOAD";

export const FETCH_LANDING = "FETCH_LANDING";
export const FETCH_ITEM_LANDING = "FETCH_ITEM_LANDING";
export const CURRENT_ITEM_LANDING = "CURRENT_ITEM_LANDING";
